// utils/subdomain.ts
export function getCurrentSubdomain() {
    const host = window.location.hostname; // e.g. attractions.domain
    const parts = host.split('.');
    // if you expect e.g. attractions.domain.com, adjust accordingly
    let subdomain = parts.length > 2
        ? parts[0] // attractions if attractions.domain.com
        : parts.length === 2
            ? parts[0] // attractions if attractions.domain
            : '';
    return (subdomain || 'changirecommends').replace('pre-prod-', '');
}
